<template>
  <div class="rankingboSum">
    <div class="microclass-header">
      <div class="microclass-header-left">本周微课排行</div>
      <div class="microclass-header-right" @click="morelist()"><span>查看更多</span><i class="el-icon-arrow-right"></i></div>
    </div>
    <!-- 渐变线条 -->
    <div class="gitern"></div>
    <div class="ranking">
      <div class="rankbox">
        <div class="ranktitlt">热门排行</div>

        <div
          class="ranklist"
          v-for="(item,index) in QuestionList"
          :key="index"
          @click="microRanking(item.id)"
        >
          <div class="ranklist-left">
            <div class="numberbgc">
              <span class="numbertext">{{index+1}}</span>
            </div>
            <img :src="item.imgUrl" />
            <div class="rankRinght">
              <div class="ranklist-name">{{item.name}}</div>
              <div class="ranklist-text">云南省武警总队大理支队</div>
              <div class="comment-box">
                <img src="@/assets/images/traningschool/videoplimg.png" />
                <span class="comment-box-text">23</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rankbox">
        <div class="ranktitlt">新课排行</div>

        <div
          class="ranklist"
          v-for="(item,index) in QuestionList"
          :key="index"
          @click="microRanking(item.id)"
        >
          <div class="ranklist-left">
            <div class="numberbgc">
              <span class="numbertext">{{index+1}}</span>
            </div>
            <img :src="item.imgUrl" />
            <div class="rankRinght">
              <div class="ranklist-name">{{item.name}}</div>
              <div class="ranklist-text">云南省武警总队大理支队</div>
              <div class="comment-box">
                <img src="@/assets/images/traningschool/videoplimg.png" />
                <span class="comment-box-text">23</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rankbox">
        <div class="ranktitlt">五星评价</div>
        <div
          class="ranklist"
          v-for="(item,index) in QuestionList"
          :key="index"
          @click="microRanking(item.id)"
        >
          <div class="ranklist-left">
            <div class="numberbgc">
              <span class="numbertext">{{index+1}}</span>
            </div>
            <img :src="item.imgUrl" />
            <div class="rankRinght">
              <div class="ranklist-name">{{item.name}}</div>
              <div class="ranklist-text">云南省武警总队大理支队</div>
              <div class="comment-box">
                <img src="@/assets/images/traningschool/videoplimg.png" />
                <span class="comment-box-text">23</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as studyClassIndex from '@/api/studyClass/index';
export default {
  data() {
    return {
      list: [
        {
          id: 1,
          name: '道路交通的法与责',
          title: '云南省武警总队大理支队',
          Number: 30,
          url: require('@/assets/policeAcademy/微课01.svg'),
          color: '#DC262D',
        },
        {
          id: 2,
          name: '道路交通的法与责',
          title: '云南省武警总队大理支队',
          Number: 25,
          url: require('@/assets/policeAcademy/微课02.svg'),
          color: '#227DE5',
        },
        {
          id: 3,
          name: '警察公共关系',
          title: '云南省武警总队大理支队',
          Number: 29,
          url: require('@/assets/policeAcademy/微课03.svg'),
          color: '#E58322',
        },
        {
          id: 4,
          title: '云南省武警总队大理支队',
          name: '犯罪心理学',
          Number: 26,
          url: require('@/assets/policeAcademy/微课04.svg'),
        },
        {
          id: 5,
          title: '警察礼仪',
          name: '道路交通的法与责',
          Number: 25,
          url: require('@/assets/policeAcademy/微课05.svg'),
        },
      ],
      levels: 5,
      QuestionList: [],
    };
  },
  mounted() {
    this.MoocQuestionList();
  },
  methods: {
    MoocQuestionList() {
      let data = { top: 5, levels: this.levels };
      studyClassIndex.MoocQuestionList(data).then((res) => {
        this.QuestionList = res.result;
      });
    },
    microRanking(id) {
      this.$router.push('/studyclassDetail?id=' + id);
    },
    morelist() {
      this.$router.push('/mooc/policeAcademyMore');
    },
  },
};
</script>

<style lang="scss" scoped>
.rankingboSum {
  width: 1200px;
  margin: 20px 0 0 0;
  background-color: #fff;
}
.microclass-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding-left: 20px;
  .microclass-header-left {
    font-size: 22px;
    color: #1492ff;
    font-weight: bold;
  }
  .microclass-header-right {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #1492ff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
            color: #1492ff;
    }
  }
}
.ranking {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  .rankbox {
    width: 386px;
    background: #ffffff;
    opacity: 1;
    border-radius: 6px;
    box-shadow: 2px 2px 5px rgb(215 215 215 / 97%);
    margin: 0 7px;
    .ranktitlt {
      height: 56px;
      padding-left: 20px;
      font-size: 20px;
      font-weight: 700;
      line-height: 50px;
    }
    .ranklist {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .ranklist-left {
        display: flex;
        margin: 10px 0;
        cursor: pointer;
        &:hover {
        }
        > img {
          width: 140px;
          height: 80px;
        }
        .numberbgc {
          width: 20px;

          text-align: center;
          line-height: 20px;
          margin-left: 20px;
          margin-right: 16px;
          display: flex;
          align-items: center;
          .numbertext {
            font-size: 28px;
            font-weight: 400;
            color: #666666;
          }
        }
      }
    }
  }
}

.rankRinght {
  flex: 1;
  padding-left: 15px;
  .ranklist-name {
    font-size: 16px;
  }
  .ranklist-text {
    font-size: 14px;
    color: #999;
    padding: 10px 0;
  }
  .comment-box {
    display: flex;
    align-items: center;
    line-height: 20px;
    > img {
      width: 20px;
      height: 20px;
      background: rgba(0, 0, 0, 0);
      opacity: 1;
      margin: 0 4px;
    }
    .comment-box-text {
      width: 13px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      opacity: 1;
      margin-right: 1px;
    }
  }
}
.gitern {
  height: 1px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}
</style>